import React from 'react';
import './Navigation.css';
import { useBrowserInfo } from '../hooks/useBrowserInfo';
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowRight02Icon } from '@hugeicons-pro/core-stroke-sharp';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';

function Navigation({ onOpenMobileMenu = undefined }) {
  const { currentTime } = useBrowserInfo();
  const location = useLocation();
  const [zoomed, setZoomed] = React.useState(false);
  React.useEffect(() => {
    const onZoom = (e) => { try { setZoomed(!!e.detail?.zoomed); } catch(_) { setZoomed(false); } };
    window.addEventListener('workZoomChange', onZoom);
    return () => window.removeEventListener('workZoomChange', onZoom);
  }, []);
  return (
    <motion.header initial={false} animate={{ y: zoomed ? '-100%' : 0 }} transition={{ type: 'tween', ease: [0.22, 1, 0.36, 1], duration: 0.38 }}>
      <nav >
        <div className="nav-title">
          <span className="nav-name">Todd Hamilton</span>
          <span className="nav-subtitle">Product Designer</span>
        </div>

        <div className="nav-menu">
          {[
            { label: 'Work ©', to: '/' },
            { label: 'About', to: '/about' }
          ].map((item) => {
            const isActive = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                className={isActive ? 'active' : ''}
                onClick={() => {
                  try { window.dispatchEvent(new CustomEvent('navNavigating', { detail: { to: item.to } })); } catch(_) {}
                }}
              >
                <span className="nav-arrow-slot">
                  <motion.span
                    initial={false}
                    animate={{ x: isActive ? 0 : -8, opacity: isActive ? 1 : 0 }}
                    whileHover={!isActive ? { x: 0, opacity: 1 } : undefined}
                    transition={{ type: 'tween', ease: 'easeOut', duration: 0.18 }}
                  >
                    <HugeiconsIcon icon={ArrowRight02Icon} size={11} color="currentColor" />
                  </motion.span>
                </span>
                {item.label}
              </Link>
            );
          })}
        </div>

        <div className="nav-contact">
          <span>Contact</span>
          <div className="social-links">
            <a href="https://twitter.com/toddham" target="_blank" rel="noopener noreferrer">X</a>
            <a href="https://instagram.com/toddham" target="_blank" rel="noopener noreferrer">IG</a>
            <a href="https://linkedin.com/in/toddham" target="_blank" rel="noopener noreferrer">IN</a>
            <a href="mailto:toddham@gmail.com" target="_blank" rel="noopener noreferrer">@</a>
          </div>
        </div>

        <div className="nav-location">
          <span>Portland, ME</span>
          <span className="nav-subtitle">{currentTime}</span>
        </div>
      </nav>
    </motion.header>
  );
}

export default Navigation;
